<!-- 视频 -->
<template>
<div class='video'>
  <img src="../../../assets/icons/diversion_bg.jpeg" alt="" class="img-f">
  <span v-if="name"  class="skill">每日小技巧: {{name}}</span>
  <div v-if="listData.length" class="date">
    <span class="month">{{isShowMorning?listData[1].filteredPublishDateMonth:listData[0].filteredPublishDateMonth}}</span>
    <span class="day">{{isShowMorning?listData[1].filteredPublishDateDay:listData[0].filteredPublishDateDay}}</span>
  </div>
  <video
    v-show="started"
    :src="url"
    :style="style"
    ref="video"
    class="try-video-main"
    playsinline="true"
    webkit-playsinline="true"
    controls
    controlsList="nodownload"
  />
  <div
    class="play"
    v-if="!started"
    @click.stop='handlePlay(true)'
  >
  </div>
  <div class="msg">
    <span class="time">每天0: 00更新</span>
    <span class="des">本课程由“WPS丨才博精品课”提供</span>
  </div>
</div>
</template>

<script>

export default {
  components: {},
  props: {
    url: String,
    image: String,
    started: Boolean,
    name: String,
    listData: Array,
    isShowMorning: Boolean,
    changeBool: Function,
  },
  data() {
    return {
      // started: false,
    };
  },
  computed: {
    style () {
      return {
        opacity: Number(this.started)
      }
    },
    video () {
      return this.$refs.video
    }
  },
  watch: {
    url() {
      setTimeout(()=>{
        this.$refs.video.play()
      },100)
    }
  },
  methods: {
    handlePlay(bool=false) {
      this.$emit('changeBool', bool)
      this.started = true
      this.$refs.video.play()
    },
    // handleStop() {
    //   this.started = false
    //   console.log(this.$refs.video)
    //   this.$refs.video.play()
    // }
  },
  created() {

  },
  mounted() {

  },
}
</script>
<style lang='scss' scoped>
  @charset "UTF-8";

  @import "../../../style/main";
.video {
  width:rem(686);
  height:rem(456);
  background:rgba(255,255,255,1);
  box-shadow:rem(0) rem(2) rem(30) rem(0) rgba(189,201,209,0.56);
  // border-radius:rem(17) rem(17) 0 0;
  border-radius:rem(17);
  margin-top: rem(30);
  overflow: hidden;
  position: relative;
  z-index: 0;
  .img-f {
    width: 100%;
    height: rem(387);
    z-index: 99;
  }
  .skill {
    position: absolute;
    top:rem(260);
    left: rem(93);
    width:rem(500);
    height:rem(33);
    font-size:rem(33);
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:rem(50);
    text-align: center;
  }
  video {
    width: 100%;
    height: rem(387);
    object-fit: fill;/*这里是关键*/
    // border-radius:rem(17);
    border-radius:rem(17) rem(17) 0 0;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
  }
  .date {
    position: absolute;
    top: rem(24);
    left: rem(24);
    width: rem(72);
    height: rem(72);
    background:rgba(153,153,153,0.1);
    border-radius:rem(6);
    border:rem(1) solid rgba(153,153,153,0.3);
    text-align: center;
    font-size: rem(28);
    font-weight:500;
    color: #999;
    line-height:rem(36);
    .month {
      display: block;
      border-bottom: rem(1) solid rgba(153,153,153,.4);
    }
    .day {
      color: #666;
      font-size: rem(34);
    }
  }
  .play {
    width: rem(120);
    height: rem(120);
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-80%);
    background:rgba(255,255,255,0.25) url('../../../assets/icons/diversion_play.png') no-repeat;
    background-size: 100% 100%;
    border-radius: rem(60);
  }
  .msg {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: rem(69);
    font-size: rem(22);
    color: #999;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .time {
      margin-left: rem(32);
    }
    .des {
      margin-right: rem(32);
    }
  }
}

.try-video-main {
  video::-internal-media-controls-download-button {
      display:none;
  }
  
  video::-webkit-media-controls-enclosure {
      overflow:hidden;
  }
  
  video::-webkit-media-controls-panel {
      width: calc(100% + 30px);
  }
}

</style>
